import React from 'react';
import Scrollchor from 'react-scrollchor';
import Scrollspy from 'react-scrollspy';
import { Col, Row, Alert } from '../../../components/Bootstrap';

import { VenueInput } from './../../../globalTypes';
import { VenueQuery_venue as Venue, VenueQuery_menus as Menu } from './__generated__/VenueQuery';
// import { AccountSection } from './AccountSection';
import { BusinessSection } from './BusinessSection';
import { GenericSection } from './GenericSection';
import { InfoSection } from './InfoSection';
import './Manage.scss';
import { OwnerSection } from './OwnerSection';
import { PaymentSection } from './PaymentSection';
import { SquareSetupSection } from './SquareSetupSection';
import { MutationResult } from 'react-apollo';
import { QueueSyncMutation, QueueSyncMutationVariables } from './__generated__/QueueSyncMutation';

const offset = -200;

interface ManageVenueProps {
  venue?: Venue;
  menus?: Menu[];
  posSetupConfig?: any;
  loading: boolean;
  editing?: string;
  squareCallbackOpen: boolean;
  squareError?: string;
  squareRevoked?: boolean;
  syncQueued?: boolean;
  queueSyncStatus?: MutationResult<QueueSyncMutation>;
  queueSync({ variables }: { variables: QueueSyncMutationVariables });
  onCancelEditing();
  onStartEditing(section: string);
  onSubmit(data: VenueInput);
  revokePOSAccess();
}

export class ManageVenue extends React.Component<ManageVenueProps, any> {
  render() {
    if (this.props.loading || !this.props.venue) {
      return <div>Loading...</div>;
    }

    const items: Array<{
      id: string;
      title: string;
      component: any;
      options: any;
    }> = [
      {
        id: 'listing',
        title: 'Venue Information',
        component: InfoSection,
        options: {
          venue: this.props.venue,
        },
      },
      {
        id: 'owner',
        title: 'Venue Owner Information',
        component: OwnerSection,
        options: {
          venue: this.props.venue,
        },
      },
      {
        id: 'business',
        title: 'Business Information',
        component: BusinessSection,
        options: {
          venue: this.props.venue,
        },
      },
      // {
      //   id: 'account',
      //   title: 'Account Information',
      //   component: AccountSection,
      //   options: {
      //     user: this.state.user
      //   }
      // },
    ];

    if (this.props.venue.paymentProcessor === 'braintree') {
      items.push({
        id: 'payment',
        title: 'Payment Details',
        component: PaymentSection,
        options: {
          venue: this.props.venue,
        },
      });
    }

    if (this.props.venue.posIntegration === 'square') {
      items.push({
        id: 'square',
        title: 'Square Integration',
        component: SquareSetupSection,
        options: {
          venue: this.props.venue,
          posSetupConfig: this.props.posSetupConfig,
          revokePOSAccess: this.props.revokePOSAccess,
          menus: this.props.menus,
          queueSyncStatus: this.props.queueSyncStatus,
          queueSync: this.props.queueSync,
        },
      });
    }

    const itemIds = items.map((item) => item.id);
    const navItems = items.map((item, key) => (
      <li key={key} className='nav-item'>
        <Scrollchor animate={{ offset: -100 }} className='nav-link' to={`#${item.id}`}>
          {item.title}
        </Scrollchor>
      </li>
    ));

    const itemElements = items.map((item, key) => (
      <GenericSection
        onSubmit={this.props.onSubmit}
        key={key}
        id={item.id}
        title={item.title}
        options={item.options}
        component={item.component}
        onCancelEditing={this.props.onCancelEditing}
        onStartEditing={this.props.onStartEditing}
        editing={this.props.editing === item.id}
        loading={this.props.loading}
      />
    ));

    return (
      <div className='manage-venue'>
        <Alert color='primary' isOpen={this.props.squareCallbackOpen}>
          <h4 className='alert-heading'>Square Account Linked</h4>
          Your Square account is now associated with Noble.
        </Alert>
        <Alert color='danger' isOpen={this.props.squareError === 'denial'}>
          <h4 className='alert-heading'>Error Linking Your Square Account</h4>
          Your Square account was not linked because you declined access.
        </Alert>
        <Alert color='danger' isOpen={this.props.squareError === 'unknown'}>
          <h4 className='alert-heading'>Error Linking Your Square Account</h4>
          An unknown error occured while attempting to link your Square account.
        </Alert>
        <Alert color='primary' isOpen={!!this.props.squareRevoked}>
          <h4 className='alert-heading'>Square Account Revoked</h4>
          Your Square account is no longer linked.
        </Alert>
        <Row>
          <Col md={4}>
            <div className='venue-listing-sticky'>
              <Scrollspy offset={offset} className='nav flex-column' items={itemIds} currentClassName='active'>
                {navItems}
              </Scrollspy>
            </div>
          </Col>
          <Col>{itemElements}</Col>
        </Row>
      </div>
    );
  }
}
